(() => {
  const toggle = document.querySelector('[data-marcello-menu-toggle]');
  const menu = document.querySelector('[data-marcello-mobile-menu]');

  const closeMenu = ({ restoreFocus = false } = {}) => {
    if (!toggle || !menu) return;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open navigation');
    menu.hidden = true;
    document.documentElement.style.overflow = '';
    if (restoreFocus) toggle.focus();
  };

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(willOpen));
      toggle.setAttribute('aria-label', willOpen ? 'Close navigation' : 'Open navigation');
      menu.hidden = !willOpen;
      document.documentElement.style.overflow = willOpen ? 'hidden' : '';
    });
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });
  }

  const details = document.querySelectorAll('.mb2b-nav__dropdown');
  document.addEventListener('click', (event) => {
    details.forEach((item) => {
      if (!item.contains(event.target)) item.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMenu({ restoreFocus: !menu?.hidden });
    details.forEach((item) => item.removeAttribute('open'));
    document.querySelector('[data-marcello-inquiry-dialog][open]')?.close();
  });

  document.querySelectorAll('[data-marcello-mega-menu]').forEach((item) => {
    const summary = item.querySelector('summary');
    let closeTimer;
    const open = () => {
      clearTimeout(closeTimer);
      item.setAttribute('open', '');
    };
    const close = () => {
      closeTimer = window.setTimeout(() => item.removeAttribute('open'), 120);
    };
    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', close);
    item.addEventListener('focusin', open);
    summary?.addEventListener('click', (event) => {
      event.preventDefault();
      open();
    });
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });
  });

  const hero = document.querySelector('[data-marcello-hero-carousel]');
  if (hero) {
    const slides = [...hero.querySelectorAll('[data-marcello-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-marcello-hero-dot]')];
    const thumbs = [...hero.querySelectorAll('[data-marcello-hero-thumb]')];
    const progress = hero.querySelector('.mb2b-hero__progress');
    const intervalMs = 5500;
    let activeIndex = 0;
    let timer;
    const activate = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-selected', String(dotIndex === activeIndex)));
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', String(active));
      });
      if (progress) {
        progress.classList.remove('is-running', 'is-paused');
        progress.style.setProperty('--mb2b-progress-duration', `${intervalMs}ms`);
        void progress.offsetWidth;
        progress.classList.add('is-running');
      }
    };
    const stop = () => {
      window.clearInterval(timer);
      if (progress) {
        progress.classList.add('is-paused');
        progress.classList.remove('is-running');
      }
    };
    const start = () => {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (progress) {
          progress.classList.remove('is-paused', 'is-running');
          void progress.offsetWidth;
          progress.style.setProperty('--mb2b-progress-duration', `${intervalMs}ms`);
          progress.classList.add('is-running');
        }
        timer = window.setInterval(() => activate(activeIndex + 1), intervalMs);
      }
    };
    dots.forEach((dot) => dot.addEventListener('click', () => {
      activate(Number(dot.dataset.index));
      start();
    }));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      activate(Number(thumb.dataset.index));
      start();
    }));
    hero.addEventListener('pointerenter', stop);
    hero.addEventListener('pointerleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    start();
  }

  const familyRoute = document.querySelector('[data-marcello-family-route]');
  if (familyRoute) {
    const requestedFamily = new URLSearchParams(window.location.search).get('family');
    const requestedSubfamily = new URLSearchParams(window.location.search).get('subfamily');
    const panels = [...familyRoute.querySelectorAll('[data-family-panel]')];
    const catalogue = document.querySelector('[data-family-catalogue]');
    const activePanel = panels.find((panel) => panel.dataset.familyPanel === requestedFamily);
    panels.forEach((panel) => {
      panel.hidden = panel !== activePanel;
    });
    if (catalogue) catalogue.hidden = Boolean(activePanel);
    const subfamilyLabels = {
      family: 'Family / Multi-person', standard: 'Standard Fishing', pro: 'Pro Fishing',
      yoga: 'Yoga Boards', fitness: 'Fitness / Wellness', modular: 'Modular Dock',
      swim: 'Swim Platform', paddles: 'Paddles / Leashes / Pumps', fins: 'Fins / Repair Kits', bags: 'Bags / Seats / Mounts'
    };
    const subfamilyLabel = subfamilyLabels[requestedSubfamily];
    if (activePanel && subfamilyLabel) {
      const context = activePanel.querySelector('[data-family-subfamily-context]');
      if (context) {
        context.textContent = `Selected program: ${subfamilyLabel}`;
        context.hidden = false;
      }
      activePanel.querySelectorAll('a[href*="/pages/b2b-contact-us"]').forEach((link) => {
        const target = new URL(link.href, window.location.origin);
        target.searchParams.set('family', requestedFamily);
        target.searchParams.set('subfamily', requestedSubfamily);
        link.href = `${target.pathname}${target.search}${target.hash}`;
      });
    }
  }

  const contactQuery = new URLSearchParams(window.location.search);
  const contactCategory = document.querySelector('select[name="contact[product_category]"]');
  if (contactCategory) {
    const categoryLabels = {
      'sup:family': 'SUP - Family / Multi-person', 'fishing:standard': 'Fishing - Standard',
      'fishing:pro': 'Fishing - Pro', 'yoga:yoga': 'Yoga & Fitness', 'yoga:fitness': 'Yoga & Fitness',
      'dock:modular': 'Dock - Modular Dock', 'dock:swim': 'Dock - Swim Platform',
      'accessories:paddles': 'Accessories', 'accessories:fins': 'Accessories', 'accessories:bags': 'Accessories'
    };
    const category = categoryLabels[`${contactQuery.get('family')}:${contactQuery.get('subfamily')}`];
    if (category && [...contactCategory.options].some((option) => option.value === category || option.textContent === category)) {
      contactCategory.value = category;
    }
  }

  const categoryTabs = document.querySelectorAll('[data-marcello-category-tab]');
  const categoryPanels = document.querySelectorAll('[data-marcello-category-panel]');
  if (categoryTabs.length && categoryPanels.length) {
    const activate = (target) => {
      categoryTabs.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.target === target)));
      categoryPanels.forEach((panel) => {
        const active = panel.id === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };
    categoryTabs.forEach((button) => button.addEventListener('click', () => activate(button.dataset.target)));
  }

  const collectionTrigger = document.querySelector('[data-marcello-category-trigger]');
  const collectionSwitcher = document.querySelector('[data-marcello-collection-switcher]');
  if (collectionTrigger && collectionSwitcher) {
    collectionTrigger.addEventListener('click', () => {
      const open = collectionTrigger.getAttribute('aria-expanded') !== 'true';
      collectionTrigger.setAttribute('aria-expanded', String(open));
      collectionSwitcher.classList.toggle('is-open', open);
    });
  }

  document.querySelectorAll('[data-marcello-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-marcello-carousel-track]');
    const prev = carousel.querySelector('[data-marcello-carousel-prev]');
    const next = carousel.querySelector('[data-marcello-carousel-next]');
    const dots = carousel.querySelector('[data-marcello-carousel-dots]');
    if (!track) return;
    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    const renderDots = () => {
      if (!dots) return;
      const count = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
      dots.replaceChildren(...Array.from({ length: count }, (_, index) => {
        const dot = document.createElement('span');
        dot.classList.toggle('is-active', index === Math.round(track.scrollLeft / track.clientWidth));
        return dot;
      }));
    };
    track.addEventListener('scroll', renderDots, { passive: true });
    window.addEventListener('resize', renderDots);
    renderDots();
  });

  const wireTabs = (tabSelector, panelSelector, selectedAttribute) => {
    const tabs = document.querySelectorAll(tabSelector);
    const panels = document.querySelectorAll(panelSelector);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => item.setAttribute(selectedAttribute, String(item === tab)));
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.dataset.target; });
    }));
  };
  wireTabs('[data-marcello-quality-tab]', '[data-marcello-quality-panel]', 'aria-selected');
  wireTabs('[data-marcello-faq-tab]', '[data-marcello-faq-panel]', 'aria-selected');

  const dialog = document.querySelector('[data-marcello-inquiry-dialog]');
  if (dialog) {
    let selectedTopic = '';
    document.querySelectorAll('[data-marcello-inquiry-open]').forEach((link) => link.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.showModal();
    }));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.querySelectorAll('[data-marcello-quick-reply]').forEach((reply) => reply.addEventListener('click', () => {
      selectedTopic = reply.textContent.trim();
      dialog.querySelectorAll('[data-marcello-quick-reply]').forEach((item) => item.classList.toggle('is-selected', item === reply));
    }));
    dialog.querySelector('[data-marcello-inquiry-continue]')?.addEventListener('click', () => {
      if (selectedTopic) window.sessionStorage.setItem('marcelloInquiryTopic', selectedTopic);
      dialog.close();
    });
  }
  const inquiryField = document.querySelector('textarea[name="contact[body]"]');
  const savedTopic = window.sessionStorage.getItem('marcelloInquiryTopic');
  if (inquiryField && savedTopic && !inquiryField.value) {
    inquiryField.value = `Inquiry topic: ${savedTopic}\n\n`;
    window.sessionStorage.removeItem('marcelloInquiryTopic');
  }

  document.querySelectorAll('.product-details a[href="#"]').forEach((link) => link.addEventListener('click', async (event) => {
    event.preventDefault();
    try {
      await navigator.clipboard.writeText(window.location.href);
      link.textContent = 'COPIED';
      window.setTimeout(() => { link.textContent = 'LINK'; }, 1600);
    } catch {
      window.prompt('Copy this product link', window.location.href);
    }
  }));

  document.querySelectorAll('[data-marcello-reveal-group]').forEach((group) => {
    group.querySelectorAll('[data-marcello-reveal]').forEach((item, index) => item.style.setProperty('--mb2b-reveal-order', index));
  });
  const revealItems = document.querySelectorAll('[data-marcello-reveal]');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }
  const revealRoot = document.querySelector('.page-wrapper');
  const revealViewport = () => {
    const rootRect = revealRoot?.getBoundingClientRect() || { top: 0, bottom: window.innerHeight, height: window.innerHeight };
    const threshold = rootRect.bottom - rootRect.height * 0.06;
    revealItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.top < threshold && rect.bottom > rootRect.top) item.classList.add('is-visible');
    });
  };
  (revealRoot || window).addEventListener('scroll', revealViewport, { passive: true });
  window.addEventListener('resize', revealViewport);
  revealViewport();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, root: revealRoot, rootMargin: '0px 0px -6% 0px' });
  revealItems.forEach((item) => observer.observe(item));
})();
